import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { HttpAuthenticationProvider } from './http-authentication-provider';
import { HttpError } from './http-error';
import { HttpRequest } from './http-request';
import { HttpRequestClient } from './http-request-client';
import { HttpRequestBuilder } from './http-request.builder';
import { UserAuthService } from '@one/user-identity-access';
import { AuthCredential, AuthStorage } from '../../repositories/lib/auth';
import { AuthResponse } from '../../repositories/lib/auth/model/auth-response.model';
import { HttpRequestMethod } from './http-request-method';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomerPortalProvider extends HttpAuthenticationProvider {
  private req = new HttpRequestBuilder('/oauth');

  constructor(
    private oAuthService: UserAuthService,
    private authStorage: AuthStorage,
    private router: Router
  ) {
    super();
  }

  public override authenticate(request: HttpRequest): void {
    const creds = this.authStorage.getCredential();
    if (creds?.idToken) {
      request.header('Authorization', 'Bearer ' + creds.idToken);
    }
  }

  public override onAccessForbidden(
    http: HttpRequestClient,
    req: HttpRequest,
    res: Observable<HttpResponse<any>>
  ): Observable<HttpResponse<any>> {
    return null as any;
  }

  public override onUnathenticated(
    http: HttpRequestClient,
    req: HttpRequest,
    res: Observable<HttpResponse<any>>,
    error?: HttpError | undefined
  ): Observable<boolean> {
    const sub = new Subject<boolean>();
    const creds = this.authStorage.getCredential();
    if (creds && creds.refreshToken) {
      this.reauthenticate(http, creds.refreshToken).subscribe({
        next: (authResponse: AuthResponse) => {
          this.authStorage.setCredential(
            new AuthCredential(
              authResponse.access_token,
              authResponse.refresh_token,
              authResponse.id_token,
              authResponse.session
            )
          );
          sub.next(true);
          sub.complete();
        },
        error: (err) => {
          this.authStorage.clear();
          sub.next(false);
          sub.complete();
          this.router.navigate(['/']);
        },
      });
    }

    return sub;
  }

  private reauthenticate(
    http: HttpRequestClient,
    refreshToken: string
  ): Observable<AuthResponse> {
    const input = new FormData();
    input.append('refresh_token', refreshToken);
    input.append('grant_type', 'refresh_token');

    return http.callObject<AuthResponse>(
      this.req
        .public('token')
        .header(
          'Authorization',
          this.authStorage.getClientAPIAuthorizationHeader()
        )
        .method(HttpRequestMethod.POST)
        .body(input)
    );
  }
}
